import { render, staticRenderFns } from "./LectureDetail.vue?vue&type=template&id=2d838d7c&scoped=true&"
import script from "./LectureDetail.vue?vue&type=script&lang=js&"
export * from "./LectureDetail.vue?vue&type=script&lang=js&"
import style0 from "./LectureDetail.vue?vue&type=style&index=0&id=2d838d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d838d7c",
  null
  
)

export default component.exports